export const SET_LOAN_UPLOAD_DATA = 'SET_LOAN_UPLOAD_DATA';
export const SET_IS_LOADING_STATE = 'SET_IS_LOADING_STATE';
export const SET_IS_UPLOADING_STATE = 'SET_IS_UPLOADING_STATE';
export const SET_TABLE_OPTIONS_OBJECT = 'SET_TABLE_OPTIONS_OBJECT';
export const SET_SELECTED_LOAN_UPLOAD = 'SET_SELECTED_LOAN_UPLOAD';
